import enCommon from "./en/common.json";
import enLayout from "./en/layout.json";
import enAuth from "./en/auth.json";
import enSites from "./en/sites.json";
import enDomains from "./en/domains.json";
import enDns from "./en/dns.json";
import enMail from "./en/mail.json";
import enDatabases from "./en/databases.json";
import enCache from "./en/cache.json";
import enBackups from "./en/backups.json";
import enStorage from "./en/storage.json";
import enSecurity from "./en/security.json";
import enClusters from "./en/clusters.json";
import enBuilds from "./en/builds.json";
import enSystem from "./en/system.json";
import enSettings from "./en/settings.json";
import enPortal from "./en/portal.json";
import enNotifications from "./en/notifications.json";
import enHosting from "./en/hosting.json";
import enHostingGit from "./en/hostingGit.json";
import enHostingScans from "./en/hostingScans.json";
import enHostingSiteTools from "./en/hostingSiteTools.json";

import roCommon from "./ro/common.json";
import roLayout from "./ro/layout.json";
import roAuth from "./ro/auth.json";
import roSites from "./ro/sites.json";
import roDomains from "./ro/domains.json";
import roDns from "./ro/dns.json";
import roMail from "./ro/mail.json";
import roDatabases from "./ro/databases.json";
import roCache from "./ro/cache.json";
import roBackups from "./ro/backups.json";
import roStorage from "./ro/storage.json";
import roSecurity from "./ro/security.json";
import roClusters from "./ro/clusters.json";
import roBuilds from "./ro/builds.json";
import roSystem from "./ro/system.json";
import roSettings from "./ro/settings.json";
import roPortal from "./ro/portal.json";
import roNotifications from "./ro/notifications.json";
import roHosting from "./ro/hosting.json";
import roHostingGit from "./ro/hostingGit.json";
import roHostingScans from "./ro/hostingScans.json";
import roHostingSiteTools from "./ro/hostingSiteTools.json";

import type { Language, NestedKeyOf } from "@/lib/i18n/types";

export const en = {
  common: enCommon,
  layout: enLayout,
  auth: enAuth,
  sites: enSites,
  domains: enDomains,
  dns: enDns,
  mail: enMail,
  databases: enDatabases,
  cache: enCache,
  backups: enBackups,
  storage: enStorage,
  security: enSecurity,
  clusters: enClusters,
  builds: enBuilds,
  system: enSystem,
  settings: enSettings,
  portal: enPortal,
  notifications: enNotifications,
  hosting: enHosting,
  hostingGit: enHostingGit,
  hostingScans: enHostingScans,
  hostingSiteTools: enHostingSiteTools,
};

export const ro = {
  common: roCommon,
  layout: roLayout,
  auth: roAuth,
  sites: roSites,
  domains: roDomains,
  dns: roDns,
  mail: roMail,
  databases: roDatabases,
  cache: roCache,
  backups: roBackups,
  storage: roStorage,
  security: roSecurity,
  clusters: roClusters,
  builds: roBuilds,
  system: roSystem,
  settings: roSettings,
  portal: roPortal,
  notifications: roNotifications,
  hosting: roHosting,
  hostingGit: roHostingGit,
  hostingScans: roHostingScans,
  hostingSiteTools: roHostingSiteTools,
};

export const locales: Record<Language, typeof en> = {
  en,
  ro,
};

export type Translations = typeof en;
export type TranslationKey = NestedKeyOf<Translations>;
